export default "__VITE_ASSET__ce5b1174__"